import { useState } from "react";
import { SupportDialog, type SupportDialogContext } from "./support-dialog";
import { useSupportT } from "./support-i18n";

/**
 * Ссылка «Поддержка» под карточкой входа.
 *
 * Стоит в подвале `AuthCard`, а не на отдельных экранах, и потому появляется
 * везде разом: на вводе почты, на вводе кода, на «Продолжить как …», на экране
 * ошибки и на «младше 16». До неё человек, которому не приходит код, видел
 * почтовый адрес строкой — и то не на всех экранах.
 */
export function SupportLink({ context }: { context?: SupportDialogContext }) {
	const t = useSupportT();
	const [open, setOpen] = useState(false);

	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="iec-press tap-target focus-ring t-meta rounded-control px-3 py-1.5 text-fg-muted transition-colors duration-[var(--dur-hover)] not-disabled:hover:text-brand-text"
			>
				{t("link")}
			</button>
			<SupportDialog open={open} onOpenChange={setOpen} {...(context ? { context } : {})} />
		</>
	);
}
